<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
            <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
                <button mat-icon-button color="primary">
                <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
                </button>
            </div>
            <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
                <div class="p-4">
                <p>
                    Clases de pago que se usan en ventas. Ej.: contado,
                    crédito, parcial, anticipo. Úsalo para definir cómo
                    se registra cada pago y qué validaciones aplica.
                </p>
                </div>
            </mat-menu>
            <h2 class="text-xl font-semibold leading-8 tracking-tight">
                Tipos de Pago
            </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Activa/inactiva, crea, actualiza y elimina los <b>tipos de pago</b> que operan dentro de AVE.
        </div>
      </div>
      <!-- Header -->
      <div
          class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
          <div class="flex shrink-0">
              <!-- Title -->
              <!--<div class="text-3xl font-extrabold tracking-tight">Tipos de Pago</div> -->
              <app-status-filters [selectedStatuses]="selectedStatuses" 
                [showStatus]="[1,0]" [typeFilter]="'master'"
                (selectionFilterApply)="getList()">
            </app-status-filters>
          </div>
          <!-- Actions -->
          <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
              <!-- Add button (only icon) -->
              <button mat-icon-button color="primary" (click)="openCreateModal()" matTooltip="Nuevo Registro">
                  <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
              </button>
          </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource"
              matSort (matSortChange)="changeSort($event)" matSortDisableClear multiTemplateDataRows>

              <!-- Nombre -->
              <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
                  <td mat-cell *matCellDef="let element" class="text-sm uppercase leading-tight">
                      <b class="f-10">{{element.code}}</b><br>
                      {{ element.name }}
                  </td>
              </ng-container>

              <!-- Company -->
              <ng-container matColumnDef="company">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Compañía</th>
                  <td mat-cell *matCellDef="let element" class="text-sm uppercase">
                      <!-- <b>{{element?.company?.id}}</b><br> -->
                      {{ element?.company?.name}}
                  </td>
              </ng-container>

              <ng-container matColumnDef="requiresPhoto">
                  <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Requiere Foto</th>
                  <td mat-cell *matCellDef="let element" class="px-6 text-left">
                      <mat-slide-toggle class="custom-slide-toggle primary"
                          [checked]="element.requiresPhoto == true" [(ngModel)]="element.requiresPhoto"
                          [color]="'success'" (ngModelChange)="onRequiresPhotoChange($event, element)">
                      </mat-slide-toggle>
                  </td>
              </ng-container>

              <!-- Estado -->
              <ng-container matColumnDef="statusId">
                  <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Estado</th>
                  <td mat-cell *matCellDef="let element" class="px-6 text-left">
                      <mat-slide-toggle class="custom-slide-toggle primary" [checked]="element.statusId == 1"
                          [(ngModel)]="element.statusId" [color]="'success'"
                          (ngModelChange)="onStatusChange($event, element)">
                      </mat-slide-toggle>
                  </td>
              </ng-container>

              <!-- Acciones -->
              <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                  <td mat-cell *matCellDef="let element" class="px-6 py-3 text-left">
                      <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                          <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #actionMenu="matMenu">
                          <button mat-menu-item (click)="openEditModal(element)">
                              <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                              <span>Editar Registro</span>
                          </button>
                          <button mat-menu-item (click)="openPaymentSaleOffice(element)">
                            <mat-icon svgIcon="heroicons_outline:clipboard-document-list"></mat-icon>
                            <span>Determinación de Cuentas</span>
                          </button>
                          <button mat-menu-item (click)="openDeleteDialog(element)">
                              <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                              <span>Eliminar Registro</span>
                          </button>
                      </mat-menu>
                  </td>
              </ng-container>

              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"
                  class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

              <!-- Fila principal -->
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"></tr>
            </table>
          </div>
          <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo
              sentimos, no hay registros para mostrar.
          </div>
        </div>

        <!-- Paginación debería asignar valor a this.pageSize-->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
            <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons
                [length]="totalItems" [pageSize]="pageSize" (page)="changePage($event)"></mat-paginator>
        </div>
      </div>
    </div>

        <!-- Modales -->
        <ng-template #addModal>
            <h2 mat-dialog-title class="text-lg font-bold mb-1">Nuevo Registro</h2>
            <mat-dialog-content class="modal-content">
                <mat-tab-group>
                  <form [formGroup]="createForm">
                    <mat-tab label="Datos Generales">
                      <div class="grid grid-cols-2 gap-4">

                          <mat-form-field appearance="fill" class="w-full">
                              <mat-label>Código</mat-label>
                              <input matInput formControlName="code" name="code" required>
                          </mat-form-field>
                          <mat-form-field appearance="fill" class="w-full">
                              <mat-label>Nombre</mat-label>
                              <input matInput formControlName="name" name="name"
                                  oninput="this.value = this.value.toUpperCase()" required>
                          </mat-form-field>
                          <mat-form-field appearance="fill" class="w-full">
                              <mat-label>Método de pago</mat-label>
                              <mat-select formControlName="selectedPayment"
                                  (selectionChange)="onPaymentMethodChange($event.value)" name="paymentMethod"
                                  required>
                                  @for (payment of paymentMethodFilterList; track payment) {
                                  <mat-option [value]="payment">
                                      {{ payment.name }}
                                  </mat-option>
                                  }
                              </mat-select>
                          </mat-form-field>
                          <mat-form-field appearance="fill" class="w-full">
                              <mat-label>Descripción</mat-label>
                              <input matInput formControlName="description"
                                  name="description" required>
                          </mat-form-field>
                      </div>
                      <div class="grid grid-cols-2 gap-4">
                          <mat-form-field appearance="fill" class="w-full">
                              <mat-label>Compañía</mat-label>
                              <mat-select formControlName="companyId" name="company"
                                  required>
                                  @for (company of companyFilterList; track company) {
                                  <mat-option [value]="company._id">
                                      {{ company.name }}
                                  </mat-option>
                                  }
                              </mat-select>
                          </mat-form-field>
                          <ng-container
                              *ngIf="shouldShowPaymentFields(this.selectedPayment?.code)">
                              <mat-form-field appearance="fill" class="w-full">
                                  <mat-label>Tasa de comisión bancaria (%)</mat-label>
                                  <input matInput type="number"
                                      formControlName="bankComission" name="bankComission"
                                      required>
                              </mat-form-field>
                              <mat-form-field appearance="fill" class="w-full">
                                  <mat-label>Retención de impuesto (%)</mat-label>
                                  <input matInput type="number"
                                      formControlName="taxRetainment" name="taxRetainment"
                                      required>
                              </mat-form-field>

                              <div class="col-span-2">
                                  <app-form-section title="Valores que se establecen a menos que se configure por oficina de venta" icon="settings" iconColor="purple">
                                      <div class="grid grid-cols-2 gap-4">
                                          <mat-form-field appearance="fill" class="w-full">
                                              <mat-label>Cuenta contable</mat-label>
                                              <input matInput formControlName="accountingAccount"
                                                  name="accountingAccount" required>
                                          </mat-form-field>
                                          <mat-form-field appearance="fill" class="w-full">
                                              <mat-label>Centro de costo</mat-label>
                                              <input matInput formControlName="costCenter"
                                                  name="costCenter">
                                          </mat-form-field>
                                          <mat-form-field appearance="fill" class="w-full">
                                              <mat-label>Clave contable</mat-label>
                                              <input matInput formControlName="accountingKey"
                                                  name="accountingKey">
                                          </mat-form-field>
                                      </div>
                                  </app-form-section>
                              </div>
                          </ng-container>
                      </div>
                    </mat-tab>
                    <mat-tab label="Mobile">
                      <div class="grid grid-cols-2 gap-4">
                        <div class="col-span-1 flex items-center">
                          <span class="slide">¿Aplica para Sobrepago?</span>
                          <mat-slide-toggle formControlName="appliesOverpayment" name="appliesOverpayment" color="primary">
                          </mat-slide-toggle>
                        </div>
                        <div class="col-span-1 flex items-center">
                          <span class="slide">¿Aplica para grupo de rutas?</span>
                          <mat-slide-toggle formControlName="applyToSubRouteGroup" (change)="onToggleApplyToGroupRoutes()"
                            name="applyToSubRouteGroup" color="primary">
                          </mat-slide-toggle>
                        </div>
                        <div class="col-span-1 flex items-center">
                          <span class="slide">¿Aplica para todas las rutas?</span>
                          <mat-slide-toggle formControlName="applyToAllSubRoutes" name="applyToAllSubRoutes"
                            (change)="onToggleApplyToAllRoutes()" color="primary">
                          </mat-slide-toggle>
                        </div>
                      
                        <ng-container *ngIf="!createForm.value.applyToSubRouteGroup">
                          <mat-form-field appearance="fill" class="col-span-2">
                            <mat-label for="group-select">Grupo de Rutas</mat-label>
                            <mat-select [formControl]="routeGroupMultiCtrl" (selectionChange)="onSelectionChangeGroupRoutes()"
                              placeholder="Seleccione los grupos de ruta" [multiple]="true" [disabled]="applyToTheseSubRouteGroup">
                              <mat-option>
                                <ngx-mat-select-search [formControl]="routeGroupMultiFilterCtrl"
                                  [placeholderLabel]="'Buscar grupos de ruta...'"
                                  [noEntriesFoundLabel]="'No se encontraron resultados'"></ngx-mat-select-search>
                              </mat-option>
                              <mat-option *ngFor="let route of filteredGroupRoute | async" [value]="route">
                                <span>
                                  <b *ngIf="getCode(route) as code">
                                    {{ code }} -
                                  </b>{{ route.name }}
                                </span>
                      
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </ng-container>
                        <ng-container *ngIf="!createForm.value.applyToAllSubRoutes">
                          <mat-form-field appearance="fill" class="col-span-2">
                            <mat-label for="group-select">Rutas</mat-label>
                            <mat-select [formControl]="routeMultiCtrl" placeholder="Seleccione las rutas" [multiple]="true"
                              [disabled]="applyToAllSubRoutes">
                              <mat-option>
                                <ngx-mat-select-search [formControl]="routeMultiFilterCtrl" [placeholderLabel]="'Buscar grupos de ruta...'"
                                  [noEntriesFoundLabel]="'No se encontraron resultados'"></ngx-mat-select-search>
                              </mat-option>
                              <mat-option *ngFor="let route of filteredRoute | async" [value]="route">
                                <span>
                                  <b *ngIf="getCode(route) as code">
                                    {{ code }} -
                                  </b>{{ route.name }}
                                </span>
                      
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </ng-container>
                      </div>
                    </mat-tab>
                  </form>
                </mat-tab-group>
            </mat-dialog-content>
            <mat-dialog-actions class="modal-actions flex justify-end">
                <button mat-button mat-dialog-close class="align-left">Cancelar</button>
                <button mat-raised-button color="primary" (click)="createPaymentType()"
                    [disabled]="!createForm.valid">Guardar</button>
            </mat-dialog-actions>
        </ng-template>

        <!-- Modal Editar -->
        <ng-template #editModal>
            <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Registro</h2>
            <mat-dialog-content class="modal-content">
                <mat-tab-group>
                  <form [formGroup]="editForm">
                    <mat-tab label="Datos Generales">
                      <div class="grid grid-cols-2 gap-4">
                          <mat-form-field appearance="fill" class="w-full">
                              <mat-label>Código</mat-label>
                              <input matInput formControlName="code" name="code" readonly
                                  disabled>
                          </mat-form-field>
                          <mat-form-field appearance="fill" class="w-full">
                              <mat-label>Nombre</mat-label>
                              <input matInput formControlName="name" name="name"
                                  oninput="this.value = this.value.toUpperCase()" required>
                          </mat-form-field>
                          <mat-form-field appearance="fill" class="w-full">
                              <mat-label>Método de pago</mat-label>
                              <mat-select formControlName="selectedPayment"
                                  (selectionChange)="onPaymentMethodChange($event.value)" name="selectedPayment"
                                  [compareWith]="comparePaymentMethods" required>
                                  @for (payment of paymentMethodFilterList; track payment) {
                                  <mat-option [value]="payment">
                                      {{ payment.name }}
                                  </mat-option>
                                  }
                              </mat-select>
                          </mat-form-field>
                          <mat-form-field appearance="fill" class="w-full">
                              <mat-label>Descripción</mat-label>
                              <input matInput formControlName="description"
                                  name="description" required>
                          </mat-form-field>
                      </div>
                      <div class="grid grid-cols-2 gap-4">
                          <!-- Campo que siempre se muestra -->
                          <mat-form-field appearance="fill" class="w-full">
                              <mat-label>Compañía</mat-label>
                              <mat-select formControlName="companyId" name="company"
                                  required>
                                  @for (company of companyFilterList; track company) {
                                  <mat-option [value]="company._id">{{ company.name }}</mat-option>
                                  }
                              </mat-select>
                          </mat-form-field>
                          <!-- Campos que se ocultan para MP00002, MP00007 y MP00008 -->
                          <ng-container
                              *ngIf="shouldShowPaymentFields(this.editForm.value.selectedPayment?.code)">
                              <mat-form-field appearance="fill" class="w-full">
                                  <mat-label>Tasa de comisión bancaria (%)</mat-label>
                                  <input matInput type="number"
                                      formControlName="bankComission" name="bankComission"
                                      required>
                              </mat-form-field>
                              <mat-form-field appearance="fill" class="w-full">
                                  <mat-label>Retención de impuesto (%)</mat-label>
                                  <input matInput type="number"
                                      formControlName="taxRetainment" name="taxRetainment"
                                      required>
                              </mat-form-field>
                              <div class="col-span-2">
                                  <app-form-section title="Valores que se establecen a menos que se configure por oficina de venta" icon="settings" iconColor="purple">
                                      <div class="grid grid-cols-2 gap-4">
                                          <mat-form-field appearance="fill" class="w-full">
                                              <mat-label>Cuenta contable</mat-label>
                                              <input matInput formControlName="accountingAccount"
                                                  name="accountingAccount" required>
                                          </mat-form-field>
                                          <mat-form-field appearance="fill" class="w-full">
                                              <mat-label>Centro de costo</mat-label>
                                              <input matInput formControlName="costCenter"
                                                  name="costCenter">
                                          </mat-form-field>
                                          <mat-form-field appearance="fill" class="w-full">
                                              <mat-label>Clave contable</mat-label>
                                              <input matInput formControlName="accountingKey"
                                                  name="accountingKey">
                                          </mat-form-field>
                                      </div>
                                  </app-form-section>
                              </div>
                          </ng-container>
                      </div>
                    </mat-tab>
                    <mat-tab label="Marca TC" *ngIf="editForm.value.selectedPayment.code ==='MP00002'">
                        <div class="table-container">
                            <table mat-table [dataSource]="currentUpdatePaymentType.paymentBrands">
                                <!-- Define columns here -->
                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef>Nombre</th>
                                    <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                                </ng-container>
                                <ng-container matColumnDef="accounting">
                                    <th mat-header-cell *matHeaderCellDef> Cuenta Contable </th>
                                    <td mat-cell *matCellDef="let element"> {{element.accountingAccount}} </td>
                                </ng-container>
                                <!-- Estado (mat-slide-toggle) -->
                                <ng-container matColumnDef="statusId">
                                    <th mat-header-cell *matHeaderCellDef class="px-6 text-center">
                                        Estado
                                    </th>
                                    <td mat-cell *matCellDef="let element" class="px-6 text-center">
                                        <mat-slide-toggle [checked]="element.statusId === 1"
                                            (change)="onStatusBrand($event.checked, element)" color="primary">
                                        </mat-slide-toggle>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="actions">
                                    <th mat-header-cell *matHeaderCellDef class="px-6 text-right">
                                        <button color="primary" mat-button (click)="openPaymentBrand()"
                                            matTooltip="Agregar marca">
                                            <mat-icon svgIcon="heroicons_solid:plus"></mat-icon>
                                        </button>
                                    </th>
                                    <td mat-cell *matCellDef="let element" class="px-6 text-right">
                                        <div class="button-container">
                                          <button mat-icon-button (click)="openBrandSaleOffice(element)"
                                            matTooltip="Determinación de Cuentas">
                                            <mat-icon svgIcon="heroicons_outline:clipboard-document-list"></mat-icon>
                                          </button>
                                            <button mat-icon-button color="primary" (click)="openPaymentBrand(element)"
                                                matTooltip="Editar Registro">
                                                <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                                            </button>
                                            <button mat-icon-button color="warn" (click)="openDeleteBrand(element)"
                                                matTooltip="Eliminar Registro">
                                                <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                                            </button>
                                        </div>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumnsBrand"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumnsBrand;"></tr>
                            </table>
                        </div>
                    </mat-tab>
                    <mat-tab label="Mobile">

                        <div class="grid grid-cols-2 gap-4">
                            <div class="col-span-1 flex items-center">
                                <span class="slide">¿Aplica para Sobrepago?</span>
                                <mat-slide-toggle formControlName="appliesOverpayment"
                                    name="appliesOverpayment" color="primary">
                                </mat-slide-toggle>
                            </div>
                            <div class="col-span-1 flex items-center">
                                <span class="slide">¿Aplica para grupo de rutas?</span>
                                <mat-slide-toggle formControlName="applyToSubRouteGroup"
                                    (change)="onToggleApplyToGroupRoutesUpdate()" name="applyToSubRouteGroup"
                                    color="primary">
                                </mat-slide-toggle>
                            </div>
                            <div class="col-span-1 flex items-center">
                                <span class="slide">¿Aplica para todas las rutas?</span>
                                <mat-slide-toggle formControlName="applyToAllSubRoutes"
                                    name="applyToAllSubRoutes" (change)="onToggleApplyToAllRoutesUpdate()"
                                    color="primary">
                                </mat-slide-toggle>
                            </div>
                            <ng-container *ngIf="!editForm.value.applyToSubRouteGroup">
                                <mat-form-field appearance="fill" class="col-span-2">
                                    <mat-label for="group-select">Grupo de Rutas</mat-label>
                                    <mat-select [formControl]="routeGroupMultiCtrl"
                                        placeholder="Seleccione los grupos de ruta"
                                        (selectionChange)="onSelectionChangeGroupRoutes()" [multiple]="true"
                                        [disabled]="editForm.value.applyToTheseSubRouteGroup">
                                        <mat-option>
                                            <ngx-mat-select-search [formControl]="routeGroupMultiFilterCtrl"
                                                [placeholderLabel]="'Buscar grupos de ruta...'"
                                                [noEntriesFoundLabel]="'No se encontraron resultados'"></ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option *ngFor="let route of filteredGroupRoute | async" [value]="route">
                                            <span>
                                                <b *ngIf="getCode(route) as code">
                                                    {{ code }} -
                                                </b>{{ route.name }}
                                            </span>

                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </ng-container>
                            <ng-container *ngIf="!editForm.value.applyToAllSubRoutes">
                                <mat-form-field appearance="fill" class="col-span-2">
                                    <mat-label for="group-select">Rutas</mat-label>
                                    <mat-select [formControl]="routeMultiCtrl" placeholder="Seleccione las rutas"
                                        [multiple]="true" [disabled]="editForm.value.applyToAllSubRoutes">
                                        <mat-option>
                                            <ngx-mat-select-search [formControl]="routeMultiFilterCtrl"
                                                [placeholderLabel]="'Buscar grupos de ruta...'"
                                                [noEntriesFoundLabel]="'No se encontraron resultados'"></ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option *ngFor="let route of filteredRoute | async" [value]="route">
                                            <span>
                                                <b *ngIf="getCode(route) as code">
                                                    {{ code }} -
                                                </b>{{ route.name }}
                                            </span>

                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </ng-container>
                        </div>
                    </mat-tab>
                  </form>
                </mat-tab-group>
            </mat-dialog-content>
            <mat-dialog-actions class="modal-actions flex justify-end">
                <button mat-button mat-dialog-close class="align-left">Cancelar</button>
                <button mat-raised-button color="primary" (click)="updatePaymentType(editForm._id)"
                    [disabled]="!editForm.valid">Guardar</button>
            </mat-dialog-actions>
        </ng-template>

        <ng-template #deleteDialog let-data>
            <div class="flex items-start space-x-2 mb-4">
                <div class="flex items-center">
                    <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
                        style="font-size: 32px;"></mat-icon>
                </div>
                <div class="grid">
                    <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
                    <mat-dialog-content class="modal-content mt-0">
                        <p>¿Está seguro que desea eliminar el registro?</p>
                    </mat-dialog-content>
                </div>
            </div>
            <mat-dialog-actions class="modal-actions flex justify-end">
                <button mat-button mat-dialog-close class="align-left">Conservar</button>
                <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
            </mat-dialog-actions>
        </ng-template>
    </div>

    <app-filter (onFilterEvent)="getList()" (onCleanEvent)="clearFilters()" (onPanelOpened)="onFilterPanelOpened()">
    <app-configuration-filters [form]="form" [company]="true" [loadData]="loadFiltersData"></app-configuration-filters>
    <app-finance-filters [form]="form"
      [paymentMethodList]="paymentMethodList"
      [loadData]="loadFiltersData"
    ></app-finance-filters>
  </app-filter>
</mat-sidenav-container>